import { createDomainTracker } from '@financial-tool/analytics';
import { planningEventsMapping } from './mapping';

export const { hook: useTracker, track } = createDomainTracker(planningEventsMapping);
export { PlanningEvents } from './events';
